import { createFileRoute } from "@tanstack/react-router";
import { CursosSector } from "@/components/cursos-sector";

const TITLE = "Cursos para Empresas Industriales | Capacitación Empresas | Mine Class";
const DESCRIPTION =
  "Planes de capacitación online para plantas y operaciones industriales: operación segura, bloqueo de energías, mantenimiento y prevención de riesgos.";

export const Route = createFileRoute("/cursos/empresas/industria")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:url", content: "https://mine-class.com/cursos/empresas/industria" },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: TITLE },
      { name: "twitter:description", content: DESCRIPTION },
    ],
    links: [{ rel: "canonical", href: "https://mine-class.com/cursos/empresas/industria" }],
  }),
  component: () => <CursosSector sector="industria" />,
});
